import dayjs from "dayjs";
import I18n from "common/i18n";
import { ProfileRow } from "./ProfileRow";

type BasicEditField = "name" | "gender" | "birthday";

type ProfileBasicTabProps = {
  icon: string;
  name: string;
  gender: string;
  selectedYear: number | null;
  selectedMonth: number | null;
  selectedDay: number | null;
  onOpenIconModal: () => void;
  onOpenEditModal: (field: BasicEditField) => void;
};

const renderName = (name: string) => {
  if (!name) {
    return (
      <span className="type-body text-textcolor-black/50 block w-[400px]">
        {I18n.t("MSG_PROFILE_NOT_SET")}
      </span>
    );
  }
  return <span className="type-body text-textcolor-black block w-[400px] truncate">{name}</span>;
};

const renderGender = (gender: string) => {
  const labelKey =
    gender === "male"
      ? "MSG_USER_PROFILE_FIELD_GENDER_MALE"
      : gender === "female"
        ? "MSG_USER_PROFILE_FIELD_GENDER_FEMALE"
        : gender === "none"
          ? "MSG_USER_PROFILE_FIELD_GENDER_NONE"
          : null;
  if (!labelKey) {
    return (
      <span className="type-body text-textcolor-black/50 block w-[400px]">
        {I18n.t("MSG_PROFILE_NOT_SET")}
      </span>
    );
  }
  return <span className="type-body text-textcolor-black block w-[400px]">{I18n.t(labelKey)}</span>;
};

const renderBirthday = (
  selectedYear: number | null,
  selectedMonth: number | null,
  selectedDay: number | null,
) => {
  const yearSuffix = I18n.t("MSG_BIRTHDAY_YEAR_SUFFIX");
  const monthSuffix = I18n.t("MSG_BIRTHDAY_MONTH_SUFFIX");
  const daySuffix = I18n.t("MSG_BIRTHDAY_DAY_SUFFIX");

  if (selectedYear && selectedMonth && selectedDay) {
    const formatted = dayjs(`${selectedYear}-${selectedMonth}-${selectedDay}`).format(
      `YYYY${yearSuffix}M${monthSuffix}D${daySuffix}`,
    );
    return <span className="type-body text-textcolor-black block w-[400px]">{formatted}</span>;
  }
  if (selectedMonth && selectedDay) {
    return (
      <span className="type-body text-textcolor-black block w-[400px]">
        {`${selectedMonth}${monthSuffix}${selectedDay}${daySuffix}`}
      </span>
    );
  }
  return (
    <span className="type-body text-textcolor-black/50 block w-[400px]">
      {I18n.t("MSG_PROFILE_NOT_SET")}
    </span>
  );
};

export const ProfileBasicTab = ({
  icon,
  name,
  gender,
  selectedYear,
  selectedMonth,
  selectedDay,
  onOpenIconModal,
  onOpenEditModal,
}: ProfileBasicTabProps) => (
  <div className="flex-col-el flex-center w-full gap-6">
    <div
      id="user-page-profile-icon"
      className="relative cursor-pointer bg-white rounded-full shrink-0 flex items-center justify-center w-[180px] h-[180px] shadow-[-1px_1px_1px_rgba(63,74,97,0.15),1px_1px_3px_rgba(63,74,97,0.25)]"
      onClick={onOpenIconModal}
      aria-label={I18n.t("MSG_USER_PROFILE_ICON_BTN")}
    >
      <div className="rounded-full overflow-hidden flex items-center justify-center w-[153px] h-[153px]">
        <img alt="プレイヤープロフィール画像" src={icon} className="w-full h-full object-contain" />
      </div>
      <div className="absolute rounded-full bg-textcolor-black/85 border-2 border-solid border-white flex items-center justify-center shadow-md pointer-events-none w-11 h-11 bottom-1 right-1">
        <span className="material-symbols-outlined type-body text-white">edit</span>
      </div>
    </div>

    <div className="flex-col-el items-center w-full max-w-[900px] gap-4 px-4">
      <ProfileRow
        label={I18n.t("MSG_USER_PROFILE_FIELD_NAME")}
        content={renderName(name)}
        onEdit={() => onOpenEditModal("name")}
      />
      <ProfileRow
        label={I18n.t("MSG_USER_PROFILE_FIELD_GENDER")}
        content={renderGender(gender)}
        onEdit={() => onOpenEditModal("gender")}
      />
      <ProfileRow
        label={I18n.t("MSG_USER_PROFILE_FIELD_BIRTHDAY")}
        content={renderBirthday(selectedYear, selectedMonth, selectedDay)}
        onEdit={() => onOpenEditModal("birthday")}
      />
    </div>
  </div>
);
